export default __webpack_public_path__ + "static/media/logo.88a0e4ff.png";